import { createFileRoute, redirect } from '@tanstack/react-router';

import { isPersonAdmin } from 'helpers/query';

export const Route = createFileRoute('/_private/_route/users/$userId/')({
  beforeLoad: ({ context, params }) => {
    if (!isPersonAdmin(context.user)) {
      throw redirect({
        params: {
          userId: params.userId,
        },
        replace: true,
        to: '/users/$userId/people',
      });
    }

    // An advisor sees a login's settings on the person page's Accounts tab,
    // next to everything else about that human. This page stays only for a
    // login with no identity row.
    const identityId = context.viewedUser.identity_uuid;
    if (identityId) {
      throw redirect({
        params: { identityId },
        replace: true,
        to: '/people/$identityId/accounts',
      });
    }
  },
});
